import { Directive, inject, Input, OnChanges } from '@angular/core';

import { type WorkflowError } from '@blaze-runtime/workflow-domain';
import { ERROR_HANDLING, ErrorHandlingComponent } from '@blaze-shared/shared-ui';
import { type Nullish } from '@blaze-shared/shared-util';

@Directive({
  selector: '[blazeWorkflowErrorHandler]',
})
export class WorkflowErrorHandlerDirective implements OnChanges {
  private readonly hostComponent = inject<ErrorHandlingComponent>(ERROR_HANDLING, {
    host: true,
  });

  @Input('blazeWorkflowErrorHandler') errors: Nullish<WorkflowError<any>[]>;
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('blazeWorkflowErrorSourceId') sourceId?: string;

  ngOnChanges(): void {
    this.handleErrorsChange();
  }

  private handleErrorsChange(): void {
    const filteredErrors = this.sourceId
      ? this.errors?.filter((error) => error.sourceId === this.sourceId)
      : this.errors;

    if (!filteredErrors?.length) {
      this.hostComponent.setErrors([]);
      return;
    }

    this.hostComponent.setErrors(filteredErrors.map((error) => error.errorMessage));
  }
}
